import './PasswordExpiredModal.sass'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button, Align } from '@sm/wds-react'
import { changePassword } from '../../actions/user'
import { a11yClick } from '../../utils/a11y'

export class PasswordExpiredModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: null,
      isSubmitting: false
    }
  }

  componentDidMount() {
    // Hide the close button (X) in the modal header
    const hideCloseButton = () => {
      // Find the modal that contains our password-expired-message
      const passwordMessage = document.querySelector('.password-expired-message')
      if (passwordMessage) {
        // Find the closest modal container
        const modal = passwordMessage.closest('.wds-modal')
        if (modal) {
          const closeButton = modal.querySelector('.wds-modal__close')
          if (closeButton) {
            closeButton.style.display = 'none'
          }
        }
      }
    }

    // Try immediately and also after a short delay to ensure modal is rendered
    hideCloseButton()
    setTimeout(hideCloseButton, 100)
    setTimeout(hideCloseButton, 500)

    // Also use MutationObserver to catch when modal is added to DOM
    const observer = new MutationObserver(hideCloseButton)
    observer.observe(document.body, { childList: true, subtree: true })

    // Cleanup observer on unmount
    this.closeButtonObserver = observer
  }

  componentWillUnmount() {
    if (this.closeButtonObserver) {
      this.closeButtonObserver.disconnect()
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { dispatch, t } = this.props
    const { currentPassword, newPassword, confirmPassword } = this.state

    // Clear previous errors
    this.setState({ error: null })

    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      this.setState({ error: t('password_expired_all_fields_required') })
      return
    }

    if (newPassword.length < 7) {
      this.setState({ error: t('password_expired_min_length_error') })
      return
    }

    if (!/[a-zA-Z]/.test(newPassword)) {
      this.setState({ error: t('password_expired_letter_required_error') })
      return
    }

    if (!/[0-9]/.test(newPassword)) {
      this.setState({ error: t('password_expired_number_required_error') })
      return
    }

    if (newPassword !== confirmPassword) {
      this.setState({ error: t('password_expired_passwords_no_match') })
      return
    }

    // Submit
    this.setState({ isSubmitting: true })
    dispatch(changePassword(currentPassword, newPassword, confirmPassword))
      .catch((error) => {
        this.setState({
          error: error.message || t('password_expired_change_failed'),
          isSubmitting: false
        })
      })
  }

  render() {
    const { currentPassword, newPassword, confirmPassword, error, isSubmitting } = this.state
    const { t } = this.props

    return (
      <Modal show={true} size='md' onClose={() => { }} dismissible={false}>
        <ModalHeader
          header={<span className='wds-modal__title'>{t('password_expired_modal_header')}</span>}
        />
        <ModalBody>
          <div className='password-expired-message'>
            {t('password_expired_message')}
          </div>
          <div className='password-expired-description'>
            {t('password_expired_description')}
          </div>

          <form onSubmit={this.handleSubmit}>
            <div className='password-form-fields'>
              <Input
                label={t('password_expired_current_password_label')}
                type='password'
                name='currentPassword'
                value={currentPassword}
                onChange={(e) => this.setState({ currentPassword: e.target.value, error: null })}
                required
                autoFocus
                disabled={isSubmitting}
                stretched
              />

              <Input
                label={t('password_expired_new_password_label')}
                type='password'
                name='newPassword'
                value={newPassword}
                onChange={(e) => this.setState({ newPassword: e.target.value, error: null })}
                required
                disabled={isSubmitting}
                stretched
              />

              <Input
                label={t('password_expired_confirm_password_label')}
                type='password'
                name='confirmPassword'
                value={confirmPassword}
                onChange={(e) => this.setState({ confirmPassword: e.target.value, error: null })}
                required
                disabled={isSubmitting}
                onKeyPress={a11yClick(this.handleSubmit)}
                stretched
              />

              {error && (
                <div className='password-error-message'>
                  {error}
                </div>
              )}
            </div>

            <div className='password-tips'>
              <strong>{t('password_expired_tips_title')}</strong>
              <ul>
                <li>{t('password_expired_tip_1')}</li>
                <li>{t('password_expired_tip_2')}</li>
                <li>{t('password_expired_tip_3')}</li>
                <li>{t('password_expired_tip_4')}</li>
                <li>{t('password_expired_tip_5')}</li>
              </ul>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Align placement='right'>
            <Button
              type='submit'
              onClick={this.handleSubmit}
              disabled={isSubmitting}
              color='primary'
            >
              {isSubmitting ? t('password_expired_submitting') : t('password_expired_submit')}
            </Button>
          </Align>
        </ModalFooter>
      </Modal>
    )
  }
}

PasswordExpiredModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

PasswordExpiredModal = withTranslation('modals')(PasswordExpiredModal)
export default connect()(PasswordExpiredModal)

